// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"161":"3b3845be","580":"091c7f9b","884":"685d8a84"}[chunkId] + ".js";
};